import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress, Button } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import Card from "@mui/material/Card";
import { termsAndConditionDefault } from "constant";
import {
  userSelector,
  updateTermsAndConditions,
  getTermsAndConditions,
} from "store/features/authSlice";
import RichTextEditor from "components/RichTextEditor";
import { toast } from "react-toastify";

const AddEditTnC = () => {
  const dispatch = useDispatch();

  const { uid, termsAndConditions } = useSelector(userSelector);
  const [tAndCText, setTAndCText] = useState(
    termsAndConditions ?? termsAndConditionDefault
  );
  const [tAndCTextError, setTAndCTextError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    dispatch(getTermsAndConditions({ uid }));
  }, [dispatch, uid]);

  const handleSubmitTAndC = () => {
    if (
      tAndCText.trim() === "" ||
      tAndCText === "<p><br></p>" ||
      tAndCText === "<div><br></div>" ||
      tAndCText === "<p>&nbsp;</p>"
    ) {
      setTAndCTextError(true);
      toast.error("t&c can't be empty");
      return;
    }
    setLoader(true);
    dispatch(updateTermsAndConditions({ newTandC: tAndCText, uid })).then(
      () => {
        dispatch(getTermsAndConditions({ uid }));
        setIsEdit(false);
        setLoader(false);
      }
    );
  };
  const handleEditorChange = (e) => {
    setTAndCText(e.target.value);
    setTAndCTextError(false);
  };
  return (
    <Card sx={{ height: "100%" }}>
      <SuiBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        padding={2}
        gap={1}
      >
        <SuiTypography mb={1} variant="h6">
          Terms and Condition
        </SuiTypography>
        <RichTextEditor
          name="termsAndConditions"
          value={tAndCText}
          name="termsAndConditions"
          toolbar={true}
          onChange={handleEditorChange}
          error={tAndCTextError}
          readOnly={!isEdit}
        />
        {isEdit ? (
          <SuiButton
            component={Button}
            color="dark"
            variant="gradient"
            onClick={handleSubmitTAndC}
            fullWidth
          >
            Submit&nbsp;
            {loader && <CircularProgress color="white" size={"1rem"} />}
          </SuiButton>
        ) : (
          <SuiButton
            component={Button}
            color="dark"
            variant="gradient"
            onClick={() => setIsEdit(true)}
            fullWidth
          >
            Edit T & C
          </SuiButton>
        )}
      </SuiBox>
    </Card>
  );
};

export default AddEditTnC;
